/*
*Ф-ция, которая преобразует известные коды ошибок в русскоязычные пояснения
*/

const errorDecryptor=(error)=>{
    //списока известных ошибок
    const errors = [];
    //user
    // errors[20101] = 'Логин/пароль неверны...';
    // errors[20102] = 'Пользователь уже зарегистрирован';
    // errors[20103] = 'Неправильный логин/пароль';
    // errors[20104] = 'Не получилось создать пользователя';
    // errors[20105] = 'Нет такого пользователя';
    // errors[20106] = 'Пользователь не подтвержден';
    // errors[20107] = 'Не получилось обновить пользователя';
    // errors[20108] = 'Не получилось создать или обновить пользователя';
    // errors[20109] = 'Неправильный код подтверждения';
    // errors[20110] = 'Пользователь уже активирован';
    // errors[20111] = 'Не подтвержден факт входа в систему';
    // errors[20112] = 'Не получилось отправить SMS';
    // //UCR
    // errors[30100] = 'Не найдена UCR запись';
    // errors[30101] = 'Не получилось обновить данные о роли';
    // errors[30102] = 'Не подтвержден факт входа в систему';
    if(error){
      let message = '';
      const { code = 0 } = error;
      if(+code<20000){
        //100xx-ошибки обмена данными с сервером
        //101xx-ошибки состояния
        //код ошибки меньше 20к пользователю расшифровку таких ошибок знать не положено!
        message = (error.message)?error.message:'Сетевая или внутренняя ошибка'
        console.log('API INTERNAL ERROR:', error);
      }else if(!errors[+code]){
        //в нашем массиве нет правильного перевода этого кода на русский язык... отдаем как есть
        message = (error.message)?error.message:'Uncnown error'
        console.log('API UNSUPPORTED ERROR:', error);
      }else{
        message = errors[+code];
      }
      return {code, message};
    }else{
      return;
    }
  }
  
  export default errorDecryptor;